import positionMan from '@/common/positionMan'
import { ExpiredState } from 'baseapp/store/expiredState'
import BaseSearchHistory from 'baseapp/views/components/BaseSearchHistory'

export default {
  appType: 'buyer',
  userOauth: {}, /* 用户token信息 */
  userInfo: new ExpiredState(null), /* 用户信息 */
  config: {},
  sellerConfig: {},
  appConfig: {mustLogin: false, hasOnlineCart: true},
  positionMan: positionMan,
  clientid: 1,
  openid: '',
  isGetWxCode: false,
  operationStatus: {},
  cartList: [], /* 购物车列表 */
  lastPaymethods: {}, /* 记录上次选择的支付方式，根据合同id和购物车记录 */
  orderInfo: {},
  buyerShopid: 0,
  supplierSkuMap: {}, /* {customid: {SKUID: {count: COUNT, checked: BOOLEAN}}} */
  baseSearchHistory: BaseSearchHistory,
  sellerCartMap: {},
  sellerCompanyid: 1,
  sellerCustomid: 0
}



// WEBPACK FOOTER //
// ./src/apps/baseapp/store/store.js